import { getRandomBrightColor, makeColorSchema } from '../color-utils';
export const randomStyle = () => makeColorSchema(getRandomBrightColor());
//# sourceMappingURL=random.style.js.map